import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _getIterator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/get-iterator';
import _extends from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/extends';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
import _defineProperty from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/defineProperty';
//
//
//
//
//
//
//
//

import PendingCollection from '~/components/dashboard/pendingAction/PendingCollection.vue';
import axios from '~/plugins/axios.js';

export default {
  name: 'PendingApprovalRange',
  components: {
    PendingCollection: PendingCollection
  },
  data: function data() {
    return _defineProperty({
      moduleSessionReturned: null,
      moduleSessionCollection: {},
      pendingApprovalCollection: {}
    }, 'moduleSessionCollection', {});
  },
  mounted: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var currentDateRaw, moduleName, searchResult, moduleSessionList, msCollection, pAppCollection, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, moduleSession, moduleSessionId, managerList, userList;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('\n\n ========= Pending Approval <|-- mounted() get all ms in 101 ========= \n');

              // let currentDateRaw = this.$moment().subtract(1,'days').startOf('day').format('X'); // 凌晨12点
              currentDateRaw = new Date();
              moduleName = '';
              _context.next = 5;
              return axios.post('/moduleSession/range', {
                currentDateRaw: currentDateRaw,
                moduleName: moduleName
              });

            case 5:
              searchResult = _context.sent.data;

              console.log('\n\n ======== PendingApprovalAddition.vue <|-- mounted() SearchResult =======\n', searchResult, '\n ---------------------');

              if (!searchResult) {
                _context.next = 58;
                break;
              }

              if (!searchResult.hasOwnProperty('moduleSessionList')) {
                _context.next = 55;
                break;
              }

              moduleSessionList = searchResult.moduleSessionList;

              this.moduleSessionReturned = moduleSessionList;

              msCollection = [];
              pAppCollection = {};
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 16;
              _iterator = _getIterator(moduleSessionList);

            case 18:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 34;
                break;
              }

              moduleSession = _step.value;
              moduleSessionId = moduleSession.id;


              msCollection[moduleSessionId] = {};
              msCollection[moduleSessionId]['moduleSession'] = moduleSession;

              _context.next = 25;
              return this.getUserMsManager(moduleSessionId);

            case 25:
              managerList = _context.sent;

              msCollection[moduleSessionId]['managers'] = managerList;

              _context.next = 29;
              return this.getPendingApprovalList(moduleSessionId, managerList);

            case 29:
              userList = _context.sent;


              pAppCollection[moduleSessionId] = userList;

            case 31:
              _iteratorNormalCompletion = true;
              _context.next = 18;
              break;

            case 34:
              _context.next = 40;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context['catch'](16);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 40:
              _context.prev = 40;
              _context.prev = 41;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 43:
              _context.prev = 43;

              if (!_didIteratorError) {
                _context.next = 46;
                break;
              }

              throw _iteratorError;

            case 46:
              return _context.finish(43);

            case 47:
              return _context.finish(40);

            case 48:

              this.moduleSessionCollection = _extends({}, msCollection);
              this.pendingApprovalCollection = _extends({}, pAppCollection);

              this.$store.commit('pendingAction/setPendingCollection', {
                msCollection: this.moduleSessionCollection,
                pAppCollection: this.pendingApprovalCollection
              });

              console.log('\n\n ====== Pending Approval Collection ===== \n', this.pendingApprovalCollection, '\n ----------------');
              console.log('\n\n ====== Pending MS Collection ===== \n', this.moduleSessionCollection, '\n ----------------');
              _context.next = 56;
              break;

            case 55:
              this.moduleSessionReturned = true;

            case 56:
              _context.next = 59;
              break;

            case 58:
              this.moduleSessionReturned = null;

            case 59:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[16, 36, 40, 48], [41,, 43, 47]]);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }(),

  methods: {
    // ============= Set managers ============
    getUserMsManager: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(moduleSessionId) {
        var managersList;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return axios.get('/userMsManager/' + moduleSessionId);

              case 2:
                managersList = _context2.sent.data;
                return _context2.abrupt('return', managersList);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getUserMsManager(_x) {
        return _ref3.apply(this, arguments);
      }

      return getUserMsManager;
    }(),


    // =========== GET PENDING APPROVAL User List ============
    getPendingApprovalList: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(moduleSessionId, managers) {
        var pendingApprovalList, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, m, userActorId, msStatusId, msStatusCode, user;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                pendingApprovalList = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 4;
                _iterator2 = _getIterator(managers);

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context3.next = 22;
                  break;
                }

                m = _step2.value;
                userActorId = m.userActorId;
                msStatusId = 'msStatus' + moduleSessionId + userActorId;
                _context3.next = 12;
                return axios.post('/userMsStatus/userMsStatusCode', { msStatusId: msStatusId });

              case 12:
                msStatusCode = _context3.sent.data.msStatusCode;

                console.log('\n\n ======= MS Status Code @Pending Approval =========\n', msStatusCode, '\n ==========');

                if (!(msStatusCode == 101)) {
                  _context3.next = 19;
                  break;
                }

                _context3.next = 17;
                return axios.get('/users/' + userActorId);

              case 17:
                user = _context3.sent.data;

                pendingApprovalList.push(user);

              case 19:
                _iteratorNormalCompletion2 = true;
                _context3.next = 6;
                break;

              case 22:
                _context3.next = 28;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3['catch'](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 28:
                _context3.prev = 28;
                _context3.prev = 29;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 31:
                _context3.prev = 31;

                if (!_didIteratorError2) {
                  _context3.next = 34;
                  break;
                }

                throw _iteratorError2;

              case 34:
                return _context3.finish(31);

              case 35:
                return _context3.finish(28);

              case 36:
                return _context3.abrupt('return', pendingApprovalList);

              case 37:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 24, 28, 36], [29,, 31, 35]]);
      }));

      function getPendingApprovalList(_x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return getPendingApprovalList;
    }(),


    // ============== APPROVE USER TO ATTEND ================
    approveUser: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(approveUserInfo) {
        var rowItem, moduleSession, rowIndex, button, userActorId, moduleSessionActorId, msStatusId, msStatus;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                rowItem = approveUserInfo.rowItem, moduleSession = approveUserInfo.moduleSession, rowIndex = approveUserInfo.rowIndex, button = approveUserInfo.button;


                console.log('\n\n ======pendingApproval.vue APPROVE-USER rowItem =========\n', rowItem, '\n ---------------------');
                console.log('\n\n ======pendingList.vue APPROVE-USER rowIndex ===========\n', rowIndex, '\n ---------------------');
                console.log('\n\n =======pendingList.vue APPROVE-USER rowItem.id ===========\n', rowItem.id, '\n ---------------------');
                console.log('\n\n =======pendingList.vue APPROVE-USER moduleSession ===========\n', moduleSession, '\n ---------------------');

                userActorId = rowItem.id;
                moduleSessionActorId = moduleSession.id;
                msStatusId = 'msStatus' + moduleSessionActorId + userActorId;


                console.log('\n\n =======pendingList.vue key of APPROVE-USER msStatusId ===========\n', msStatusId, '\n ---------------------');

                _context4.next = 11;
                return axios.post('/userMsManager/approveBooking', {
                  msStatusId: msStatusId
                });

              case 11:
                msStatus = _context4.sent.data;

                console.log('\n\n ======= pendingList.vue APPROVE-USER msStatus Received ======== \n', msStatus, '\n ---------------------');

                console.log('\n\n ======= pendingList.vue APPROVE-USER $store.state.pendingAction.userCollection  ======== \n', this.$store.state.pendingAction.userCollection, '\n ---------------------');

                this.$store.commit('pendingAction/onStatusUpdate', {
                  rowItem: rowItem,
                  moduleSessionActorId: moduleSessionActorId
                });

                console.log('\n\n ======= pendingList.vue APPROVE-USER $store.state.pendingAction.userCollection ======== \n', this.$store.state.pendingAction.userCollection, '\n ---------------------');

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function approveUser(_x4) {
        return _ref5.apply(this, arguments);
      }

      return approveUser;
    }(),

    // ============== REJECT USER TO ATTEND =================
    rejectUser: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(rejectUserInfo) {
        var rowItem, moduleSession, rowIndex, button, rejRemarks, userActorId, moduleSessionActorId, msStatusId, managerId, rejInfo;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                rowItem = rejectUserInfo.rowItem, moduleSession = rejectUserInfo.moduleSession, rowIndex = rejectUserInfo.rowIndex, button = rejectUserInfo.button, rejRemarks = rejectUserInfo.rejRemarks;

                console.log('\n\n ====== PendingApproval comp <|-- rejectUser() ======\n', rejectUserInfo, '\n =============');

                userActorId = rowItem.id;
                moduleSessionActorId = moduleSession.id;
                msStatusId = 'msStatus' + moduleSessionActorId + userActorId;
                managerId = 'userMsManager' + userActorId;
                _context5.next = 8;
                return axios.post('/userMsManager/unBookModuleSession', {
                  managerId: managerId,
                  userActorId: userActorId,
                  moduleSessionActorId: moduleSessionActorId,
                  msStatusCode: 400,
                  rejRemarks: rejRemarks
                });

              case 8:
                rejInfo = _context5.sent.data;


                console.log('\n\n======= ON REJ RESPONSE =======\n', rejInfo, '--------------');
                this.$store.commit('pendingAction/onStatusUpdate', {
                  rowItem: rowItem,
                  moduleSessionActorId: moduleSessionActorId
                });

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function rejectUser(_x5) {
        return _ref6.apply(this, arguments);
      }

      return rejectUser;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/pendingAction/PendingApprovalRange.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/pendingAction/PendingApprovalRange.vue
// module chunks = 1